import React from 'react';
import { useSelector } from 'react-redux';

import { selectGrades } from '../../../redux/reducers/GradesReducer';

import Filters from '../../common/Filters/Filters';

interface Props {
  filters: Record<string, string>;
  setFilter: (filter: string, value: string) => void;
}

const StudentsFilters = ({ filters, setFilter }: Props) => (
    <Filters
      className="d-flex flex-column gap-3 align-items-stretch"
      setFilter={setFilter}
      values={filters}
      filtersSchema={{
        username: {
          type: 'input',
          placeholder: 'ID',
        },
        sex: {
          type: 'select',
          options: [
            { label: 'Любой пол', value: '' },
            { label: 'м', value: 'м' },
            { label: 'ж', value: 'ж' },
          ],
        },
        age: {
          type: 'input',
          placeholder: 'Возраст',
        },
        grade: {
          type: 'input',
          placeholder: 'Класс',
        },
        gradeLetter: {
          type: 'input',
          placeholder: 'Буква класса',
        },
        orphan: {
          type: 'select',
          options: [
            { label: 'Сирота - Любой', value: '' },
            { label: 'Сирота - Нет', value: '0' },
            { label: 'Сирота - Да', value: '1' },
          ],
        },
        visionImpairment: {
          type: 'select',
          options: [
            { label: 'НЗ - Любой', value: '' },
            { label: 'НЗ - Нет', value: '0' },
            { label: 'НЗ - Да', value: '1' },
          ],
        },
        hearingImpairment: {
          type: 'select',
          options: [
            { label: 'НС - Любой', value: '' },
            { label: 'НС - Нет', value: '0' },
            { label: 'НС - Да', value: '1' },
          ],
        },
        musculoskeletalImpairment: {
          type: 'select',
          options: [
            { label: 'НОДА - Любой', value: '' },
            { label: 'НОДА - Нет', value: '0' },
            { label: 'НОДА - Да', value: '1' },
          ],
        },
        doneTesting: {
          type: 'select',
          options: [
            { label: 'Прошёл - Любой', value: '' },
            { label: 'Прошёл - Нет', value: '0' },
            { label: 'Прошёл - Да', value: '1' },
          ],
        },
        result: {
          type: 'select',
          options: [
            { label: 'Вероятность риска - Любая', value: '' },
            { label: 'Вероятность риска - Низкая', value: '0' },
            { label: 'Вероятность риска - Высокая', value: '1' },
            { label: 'Вероятность риска - Высочайшая', value: '2' },
          ],
        },
      }}
    />
  );

export default StudentsFilters;
